import { SelectField } from '@ff-it/form';
import type { BlockState } from 'modules/campaign/block/types';
import type { Option } from 'options';
import { useScopedActivityTypeOptions } from './useScopedActivityTypeOptions';
import { ReactNode } from 'react';
import { blockStateOptions, formatOptionLabel } from 'modules/campaign/status/BlockStateField';

// We exclude NEW
const reportBlockStateOptions: Option<BlockState>[] = blockStateOptions.filter(({ value }) => value !== 'NEW');

export function StateFilterField({ className, label }: { className?: string; label?: ReactNode }) {
  return (
    <SelectField
      name="state"
      placeholder="All states (except CANCELED)"
      options={reportBlockStateOptions}
      simple
      isMulti
      label={label}
      className={className}
      formatOptionLabel={formatOptionLabel}
    />
  );
}

export function TypeFilterField({
  className,
  global,
  label,
}: {
  className?: string;
  global: boolean;
  label?: ReactNode;
}) {
  const typeOptions = useScopedActivityTypeOptions(global);
  return (
    <SelectField
      name="type"
      placeholder="All types"
      options={typeOptions}
      simple
      isMulti
      label={label}
      className={className}
    />
  );
}
